// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xBaseTheme } from "@werner/XDL/types";
import { css } from "styled-components";

export const headingFontConfig = {
    url: "",
    weight: 500,
    fontFamily: "'Franklin Gothic', sans-serif",
};
export const fontConfig = {
    url: "",
    weight: 400,
    fontFamily: "'Franklin Gothic', sans-serif",
};

export default {
    fontFamilyImportUrl: "",
    body: {
        size: "15px",
        weight: fontConfig.weight,
        fontFamily: fontConfig.fontFamily,
        css: css`
            letter-spacing: 0;
            line-height: 17px;
        `,
    },
    p: {
        size: "16px",
        weight: fontConfig.weight,
        fontFamily: fontConfig.fontFamily,
        css: css`
            letter-spacing: 0;
            line-height: 18px;
        `,
    },
    h1: {
        size: "40px",
        weight: headingFontConfig.weight,
        fontFamily: headingFontConfig.fontFamily,
        css: css`
            letter-spacing: 0;
            line-height: 46px;
        `,
    },
    h2: {
        size: "36px",
        weight: headingFontConfig.weight,
        fontFamily: headingFontConfig.fontFamily,
        css: css`
            letter-spacing: 0;
            line-height: 41px;
        `,
    },
    h3: {
        size: "32px",
        weight: headingFontConfig.weight,
        fontFamily: headingFontConfig.fontFamily,
        css: css`
            letter-spacing: 0;
            line-height: 36px;
        `,
    },
    h4: {
        size: "28px",
        weight: headingFontConfig.weight,
        fontFamily: headingFontConfig.fontFamily,
        css: css`
            letter-spacing: 0;
            line-height: 32px;
        `,
    },
    h5: {
        size: "24px",
        weight: headingFontConfig.weight,
        fontFamily: headingFontConfig.fontFamily,
        css: css`
            letter-spacing: 0;
            line-height: 27px;
        `,
    },
    h6: {
        size: "18px",
        weight: headingFontConfig.weight,
        fontFamily: headingFontConfig.fontFamily,
        css: css`
            letter-spacing: 0;
            line-height: 20px;
        `,
    },
    headerPrimary: {
        forwardAs: "p",
        size: "16px",
        fontFamily: headingFontConfig.fontFamily,
        color: "text.main",
        transform: "uppercase",
        weight: headingFontConfig.weight,
    },
    headerSecondary: {
        forwardAs: "p",
        size: "16px",
        fontFamily: headingFontConfig.fontFamily,
        transform: "uppercase",
        color: "text.main",
        weight: headingFontConfig.weight,
    },
    headerTertiary: {
        forwardAs: "p",
        size: "16px",
        fontFamily: headingFontConfig.fontFamily,
        color: "text.main",
        transform: "uppercase",
        weight: headingFontConfig.weight,
    },
    legend: { forwardAs: "span", size: "10px", color: "text.accent", transform: "uppercase", weight: 600 },
} as xBaseTheme["typography"];
